import { PostAlarm } from 'ck-queries';

export const defaultAlarmValues: PostAlarm = {
  inboxMessageEnglish: '',
  inboxMessageSwedish: '',
  titleEnglish: '',
  titleSwedish: '',
  notificationMessageEnglish: '',
  notificationMessageSwedish: '',
  targetGroup: {
    group: '',
    count: 0,
    divisionName: '',
  },
  createdByDivisionName: '',
};
